import { useState } from "react"
import { Link } from "react-router-dom"
import AppLayout from "./AppLayout"
import { Button } from "./ui/button"
import { Card } from "./ui/card"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select"
import { CheckCircle, ChevronRight } from "lucide-react"

const HistoryScreen = () => {
  const [filter, setFilter] = useState("all")

  // This would come from an API in a real app
  const collections = [
    {
      id: 101,
      name: "Rahul Sharma",
      tests: "Complete Blood Count, Lipid Profile",
      date: "June 13, 2025",
      time: "10:30 AM",
    },
    {
      id: 102,
      name: "Priya Patel",
      tests: "Thyroid Profile, Vitamin D",
      date: "June 12, 2025",
      time: "11:45 AM",
    },
    {
      id: 103,
      name: "Amit Kumar",
      tests: "Liver Function Test, Kidney Function Test",
      date: "June 12, 2025",
      time: "01:15 PM",
    },
    {
      id: 104,
      name: "Sneha Gupta",
      tests: "HbA1c, Blood Glucose",
      date: "June 11, 2025",
      time: "02:30 PM",
    },
    {
      id: 105,
      name: "Vikram Singh",
      tests: "Complete Blood Count",
      date: "June 10, 2025",
      time: "03:45 PM",
    },
  ]

  return (
    <AppLayout>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="relative h-[100px] w-[100px] mr-3">
            <img src="/images/pranaam-365-logo.png" alt="Pranaam365 Logo" className="w-full h-full object-contain" />
          </div>
          <h1 className="text-2xl font-bold text-gray-800">Collection History</h1>
        </div>
      </div>

      <div className="flex items-center justify-between mb-6">
        <Select defaultValue={filter} onValueChange={setFilter}>
          <SelectTrigger className="w-[180px] border-gray-200 text-gray-800">
            <SelectValue placeholder="Filter by date" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Time</SelectItem>
            <SelectItem value="today">Today</SelectItem>
            <SelectItem value="week">This Week</SelectItem>
            <SelectItem value="month">This Month</SelectItem>
          </SelectContent>
        </Select>

        <Button variant="outline" size="sm" className="border-gray-200 hover:bg-gray-50 text-gray-800">
          Export
        </Button>
      </div>

      <div className="space-y-4">
        {collections.map((collection) => (
          <Card key={collection.id} className="overflow-hidden border-gray-200">
            <Link to={`/history/${collection.id}`}>
              <div className="p-4">
                <div className="flex justify-between items-start mb-2">
                  <div>
                    <h3 className="font-medium text-gray-800">{collection.name}</h3>
                    <p className="text-sm text-gray-500">{collection.tests}</p>
                  </div>
                  <ChevronRight className="h-5 w-5 text-gray-400" />
                </div>

                <div className="flex items-center">
                  <CheckCircle className="h-4 w-4 text-green-600 mr-2" />
                  <span className="text-sm text-gray-500">
                    Collected on {collection.date} at {collection.time}
                  </span>
                </div>
              </div>
            </Link>
          </Card>
        ))}
      </div>
    </AppLayout>
  )
}

export default HistoryScreen
